// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KvyU","top":"styles_top__NlRUV"};